<div class="container">
  <h3 class="mt-2">Lifting Program Module</h3>
  <!-- <app-forecast-nav></app-forecast-nav> -->
  <app-forecast-generator></app-forecast-generator>
</div>
